export default __webpack_public_path__ + "static/media/TrophyThumb.9a90f110.svg";